import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";


export default class extends Controller {
  connect() {
    flatpickr($(".date_time_picker"), {
      enableTime: true,
      dateFormat: "d.m.Y H:i",
      time_24hr: true,
      allowInput: true,
      locale: German,
    });

    flatpickr($(".date_picker"), {
      enableTime: false,
      dateFormat: "d.m.Y",
      allowInput: true,
      locale: German,
    });
  }
}
